export default __webpack_public_path__ + "_/_/public/files/Privacy_Notice_070119.pdf";